<template>
  <div
    v-if="!block.hidden && blockReady"
    :id="containerId"
    class="preview-block-editor"
    :class="{
      'opacity-0': isPresentingDefaultContent
    }"
  >
    <BlockEditor
      :component-data="componentData"
      :type="block.type"
      :preview="true"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BlockEditor from '@/components-v2/presentation-editor/middle/editors/BlockEditor.vue'

export default {
  components: {
    BlockEditor,
  },
  props: {
    block: {
      type: Object,
      default: null,
    },
    slideId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      blockInstance: null,
      blockReady: false,
    }
  },

  computed: {
    ...mapState([
      'isDisableEditPresentation',
    ]),
    ...mapGetters([
      'isPresenting',
      'isBackstage',
    ]),
    isPresentingDefaultContent() {
      if (!this.block) return false
      if (this.block.type === 'Image') return false
      if (this.block.type === 'RichText') {
        return (this.isPresenting || this.isBackstage) &&
        this.block.content &&
        this.block.content.value.includes('Click to add')
      }
      return false
    },
    componentData() {
      return {
        ...this.block,
        slideId: this.slideId,
        blockId: this.block.id,
      }
    },
    containerId() {
      return `container-${this.block.id}`
    },
  },
  mounted() {
    setTimeout(() => {
      this.blockReady = true
    }, Math.random() * 10)
  },

}
</script>

<style lang="scss" scoped>
.preview-block-editor {

  img {
    max-width: inherit;
  }
  .element-editor{
    &.preview-block-editor{
      cursor: default;
    }
    position: absolute;
    font-size: 2em;
  }

  &::v-deep .rich-text-editor {
    overflow: hidden !important;
    font-size: 2.59em !important;

    ol,
    ul {
      padding-left: 50px;
    }

    img {
      display: inline-block;
    }

    ol,
    ul {
      list-style-position: unset;
      list-style-image: unset;
      list-style-type: revert;
    }

    ul {
      list-style-type: disc;
    }
    ul ul {
      list-style-type: circle;
    }
  }

}

</style>
